import one from '../assets/png/projects/forMediumBlog.PNG'

export const blogData = [
    {
        id: 1,
        title: 'Blog on Info about Cloning E-Commerce website Mytheresa.com.',
        description: 'Find out how to build website with backend,frontend and connecting it with API. Know more about how my experience while Cloning E-Commerce website Mytheresa.com: Building Backend and Frontend.',
        date: 'Apr 1, 2022',
        image: one,
        url: 'https://medium.com/@dnyaneshwarmagar276/cloning-e-commerce-website-mytheresa-com-building-backend-and-frontend-a260616496c0'
    },
    {
        id: 2,
        title: 'Blog on Cloning E-Commerce website Bewkoof.com',
        description: 'Find out how to build websites and what a construct week at Masai school is like, from the guy who hustled through it. Know more about endeavour of building this web application from scratch usin HTML,CSS,Javascript',
        date: 'Oct 03, 2021',
        image: one,
        url: 'https://medium.com/@dnyaneshwarmagar276/cloning-e-commerce-website-bewkoof-com-ebbf6066fb04'
    },
    {
        id: 3,
        title: 'Blog on Cloning of Overstock.com',
        description: 'All you know about how to build a fully fledged MERN app',
        date: 'May 10, 2022',
        image: one,
        url: 'https://medium.com/@dnyaneshwarmagar276'
    },
    // {
    //     id: 4,
    //     title: 'CHECK INTERNET SPEED FROM THE COMMAND LINE',
    //     description: 'Want to check your internet speed from the terminal? Here\'s the perfect way to the that.',
    //     date: 'Sep 17, 2020',
    //     image: 'https://1.bp.blogspot.com/-XTVMsZP3HaM/Xxpl394txlI/AAAAAAAABws/zovXWiuNGg4TzBwYYVFfJ1ixDb3JfVokgCNcBGAsYHQ/w400-h195/speedtest.png',
    //     url: 'https://hackzism.blogspot.com/2020/07/check-internet-speed-from-command-line.html'
    // },
    // {
    //     id: 5,
    //     title: 'GET MICHAEL\'S OR TREVOR\'S VEHICLES FULLY UPGRADED IN GTA V FOR FREE',
    //     description: 'In case you haven\'t heard of this game, GTA stands for \'Grand Theft Auto\'. It is an open-world game published by Rockstar Games.',
    //     date: 'Oct 1, 2020',
    //     image: 'https://1.bp.blogspot.com/-jhdtUBIRD_s/XxLFKQuRz9I/AAAAAAAABsM/mClfbfDFKvsUwA7Wyi25Lzu3DEmL2lxrACNcBGAsYHQ/s1919/gta.jpg',
    //     url: 'https://hackzism.blogspot.com/2020/07/how-can-you-get-michaels-or-trevors.html'
    // },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/
